import React, { useEffect } from 'react';
import { TradingCell } from '@johnlewispartnership/wtr-content-component-library';

import { type BannerLink } from 'types/adtech';
import { type Banner } from 'api/definitions/adtech/types';
import { type PromoImpression } from 'analytics/promo-impressions';
import { usePromoImpression } from 'hooks/use-promo-impression';
import { EventType, sendAdTechEvent } from 'analytics/gtmServerFunctions';

export type TradingCellWrapperProps = {
  componentId?: string;
  analytics: Partial<Banner['tracking']> & { promoName?: PromoImpression['name'] };
  position: string;
  products: {
    id: string;
    lineNumber?: string;
  }[];
  isCitrusAd: boolean;
  textArea?: {
    link: BannerLink & { newWindow?: boolean };
  };
};

const TradingCellWrapper = (props: TradingCellWrapperProps) => {
  const { componentId, analytics, position, products, isCitrusAd, textArea } = props;

  const observerRef = usePromoImpression({
    componentId,
    analytics,
    position,
    products,
  });

  const isExternal = Boolean(textArea?.link?.isExternalLink || textArea?.link?.newWindow);

  useEffect(() => {
    const el = observerRef.current as HTMLElement | null;
    if (el) {
      const buttons = el.querySelectorAll<HTMLAnchorElement>('[data-testid="text-card-btn"]');
      buttons.forEach((button: HTMLAnchorElement) => {
        if (isExternal) {
          button.setAttribute('target', '_blank');
          button.setAttribute('rel', 'noopener noreferrer');
        } else {
          button.removeAttribute('target');
          button.removeAttribute('rel');
        }
      });
    }
  }, [isExternal, observerRef]);

  const promoClickHandler = () => {
    if (isCitrusAd) {
      sendAdTechEvent({
        eventType: EventType.CLICK,
        sponsorshipId: componentId,
        trackingUrls: analytics?.clickUrls,
        vendor: analytics?.vendor,
      });
    }
  };

  // @ts-expect-error `onPromoClick` property is not declared
  return <TradingCell ref={observerRef} {...props} onPromoClick={promoClickHandler} />;
};

export default TradingCellWrapper;
